import { CircularProgress } from "@mui/material";
import React from "react";

const CustomLoader = () => {
  return (
    <div
      className="pageloaderWrp"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        className="pageLoadr"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    </div>
  );
};

const Loader = () => {
  return (
    <div
      className="pageloaderWrp"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        className="pageLoadr custom_loader"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </div>
    </div>
  );
};

export default CustomLoader;
export { Loader };
